import { Heart, Sparkles } from "lucide-react";
import { BUSINESS } from "@/lib/config";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left — logo block */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div
                className="absolute -top-4 -left-4 w-full h-full border-2 border-[#002FA7]"
                aria-hidden
              />
              <div className="relative bg-slate-50 p-12 flex flex-col items-center justify-center min-h-[420px] border-2 border-slate-900 bid-noise">
                <img
                  src={BUSINESS.logoUrl}
                  alt={BUSINESS.name}
                  className="w-44 h-44 object-cover mb-6 border border-slate-300"
                />
                <div className="text-center">
                  <div className="font-display font-black text-2xl uppercase tracking-tight">
                    {BUSINESS.name}
                  </div>
                  <div className="text-xs uppercase tracking-[0.25em] text-slate-500 font-bold mt-2">
                    Est. St. Augustine, FL
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right — story */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="bid-divider" />
              <span className="bid-eyebrow">About BID DVC</span>
            </div>
            <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight mb-8">
              Superior service.
              <br />
              Personalized attention.
            </h2>

            <p className="text-lg text-slate-700 leading-relaxed mb-6">
              BID DVC provides professional service for residential and
              commercial clients for St. Augustine and surrounding areas.
              Before changing your dryer due to poor function, allow us to come
              and service the vent — in most cases the vent is simply clogged
              with lint.
            </p>

            <p className="text-base text-slate-600 leading-relaxed mb-10">
              We started with the simple idea of bringing the best from us to
              you. From our founder to our front-line workers, we put lots of
              love and careful thought into all we do. We hope you enjoy all we
              have to offer, and share the experience with others.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <Pillar
                icon={Heart}
                title="Built on care"
                text="Family-operated. Every customer is treated like a neighbor."
              />
              <Pillar
                icon={Sparkles}
                title="Done right, every time"
                text="Thorough cleaning, written safety check, photo report after each job."
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Pillar({ icon: Icon, title, text }) {
  return (
    <div className="border-l-2 border-[#002FA7] pl-5">
      <div className="flex items-center gap-2 mb-2">
        <Icon size={18} className="text-[#FF2A2A]" />
        <div className="font-display font-bold uppercase tracking-tight text-base">
          {title}
        </div>
      </div>
      <p className="text-sm text-slate-600 leading-relaxed">{text}</p>
    </div>
  );
}
